// kan-111 AI Reference Taker — notification rendering helpers.
// Kept local to the notification components (not utils/constant.tsx) on purpose.
import { Badge } from 'reactstrap';
import { SETTINGS_ROUTE, VIEW_CANDIDATE_ROUTE } from '../../../utils/constant';

// GraphQL serialises the AlertType enum by key, not by DB value.
export const AI_REFERENCE_ALERT_TYPE = 'AI_REFERENCE_UPDATE';
// Rows written since 2026-10-15 point at the candidate (notifyableId = candidate id);
// older rows point at the AiReferenceEntry and fall back to the Settings tab.
export const AI_REFERENCE_CANDIDATE_NOTIFYABLE_TYPE = 'Candidate';
export const AI_REFERENCE_NOTIFYABLE_TYPE = 'AiReferenceEntry';
// Settings → "AI References" tab (plan §9) — fallback target only.
export const AI_REFERENCE_SETTINGS_TAB_ID = '9';
// Candidate profile → "References" tab (same id the Settings page links to).
export const CANDIDATE_REFERENCES_TAB_ID = '6';

export const isAiReferenceNotification = (item?: {
  alertType?: string;
  notifyableType?: string;
}): boolean => item?.alertType === AI_REFERENCE_ALERT_TYPE;

/**
 * Where a click on an AI reference alert goes: the candidate profile's
 * References tab when the row carries the candidate id, otherwise the
 * Settings › AI References tab.
 */
export const aiReferenceNotificationLocation = (item?: {
  notifyableType?: string | null;
  notifyableId?: string | null;
}) => {
  if (item?.notifyableType === AI_REFERENCE_CANDIDATE_NOTIFYABLE_TYPE && item?.notifyableId) {
    return {
      pathname: `${VIEW_CANDIDATE_ROUTE}/${item.notifyableId}`,
      search: `?activeTab=${CANDIDATE_REFERENCES_TAB_ID}`,
    };
  }
  return {
    pathname: SETTINGS_ROUTE,
    search: `?activeTab=${AI_REFERENCE_SETTINGS_TAB_ID}`,
  };
};

export const AiReferenceNotificationLabel = () => (
  <Badge color="info" className="mr-2 align-middle" pill>
    AI Reference
  </Badge>
);
